export default {
  // 删除购物车Seminar
  deleteStudentCourseCenterCardCourse: '/api/student/course-center/cart/course/{0}',
  // 删除购物车 Capstone
  deleteStudentCourseCenterCardCourseCp: '/api/student/course-center/cart/course-cp/{0}',
  // 教师管理
  // 删除作业
  deleteTeahcerAssignment: '/api/teacher/assignment/{0}',
  deleteTeacherHour: '/api/teacher/hour/{0}',
  // 删除
  deleteApiHouseCup: '/api/admin/house-cup/{0}',
  //#region Capstone Showcase
  // 反悔喜欢
  deleteStudentCapstoneShowCaseLike: '/api/student/capstone-show-case/like/{0}',
  deleteTeacherCapstoneShowCaseLike: '/api/teacher/capstone-show-case/like/{0}',
  // 教师端 - 删除小队
  deleteActivityMissionX: '/api/activity/mission-x/{0}',
  //#endregion Capstone Showcase
  //#region 消息中心
  // 消息删除
  deleteAdminMessages: '/api/admin/messages/{0}',
  //#endregion
  // 管理端-学生管理-删除请假
  deleteAdminStudentsIdTimeSheetsId: '/api/admin/students/{0}/time-sheets/{1}'
};
